import { render, staticRenderFns } from "./ServiceSoftware.vue?vue&type=template&id=52098f39&scoped=true&"
import script from "./ServiceSoftware.vue?vue&type=script&lang=js&"
export * from "./ServiceSoftware.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSoftware.vue?vue&type=style&index=0&id=52098f39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52098f39",
  null
  
)

export default component.exports